module.exports = __webpack_public_path__ + "img/tema-3-26.495319cb.png";